// EditPartnerUserDialog.tsx
import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControlLabel,
    Switch,
    TextField,
    Typography
} from "@mui/material";
import { editPartnerUser } from "../../services/PartnerUserService";
import { PartnerUser } from "../../data/PartnerUserData";

interface EditPartnerUserDialogProps {
    isOpen: boolean;
    onClose: () => void;
    partnerId: string;
    partnerUserId: string;
    userName: string;
    isSponsorAdmin: boolean;
    onSave: () => void;
}

const EditPartnerUserDialog: React.FC<EditPartnerUserDialogProps> = ({
    isOpen,
    onClose,
    partnerId,
    partnerUserId,
    userName,
    isSponsorAdmin,
    onSave
}) => {
    const [sponsorAdmin, setSponsorAdmin] = useState<boolean>(isSponsorAdmin);

    useEffect(() => {
        setSponsorAdmin(isSponsorAdmin);
    }, [isSponsorAdmin, isOpen]);

    const handleSave = async () => {
        try {
            const updateRequest: Partial<PartnerUser> = {
                SponsorAdmin: sponsorAdmin,
            };
            await editPartnerUser(partnerUserId, updateRequest);
            onSave();
            onClose();
        } catch (error) {
            console.error("Failed to edit partner user:", error);
            alert("Failed to update partner user.");
        }
    };

    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Edit Role</DialogTitle>
            <DialogContent>
                <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                    Name
                </Typography>
                <TextField
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    value={userName || "Unknown User"}
                    InputProps={{
                        readOnly: true,
                    }}
                    style={{ backgroundColor: "#f5f5f5" }}
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={sponsorAdmin}
                            onChange={(e) => setSponsorAdmin(e.target.checked)}
                        />
                    }
                    label={sponsorAdmin ? "Sponsor Admin" : "Not a Sponsor Admin"}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditPartnerUserDialog;